// modules
import { createAction } from 'redux-actions'

export const setCompanyReferences = createAction('SET_COMPANY_REFERENCES')
